import { connect } from 'react-redux'
import { selectFilterOption } from 'actions/multi_step/workflow_overview_board_actions'

export default connect(
  (state) => {
    return state.multiStep?.workflowOverviewBoard || {}
  },
  { selectFilterOption },
)
